import React from 'react'
import { Route, Switch } from 'react-router'
import PropTypes from 'prop-types'

import BasicHeader from './BasicHeader'
import { ToggleFeature, features } from 'features/ToggleFeature'

const HeaderRoutes = ({ refererIsLogin }) => (
  <Switch>
    <Route path='/checkout/points-purchase' component={() => <ToggleFeature refererIsLogin={refererIsLogin} feature={features.HeaderFeature} />} />
    <Route path='/checkout' component={BasicHeader} />
    <Route path='/confirmation/:orderId' component={() => <ToggleFeature refererIsLogin={refererIsLogin} feature={features.HeaderFeature} />} />
    <Route path='/two-step-verification' component={BasicHeader} />
    <Route path='/faq-two-step' component={BasicHeader} />
    <Route path='/' component={() => <ToggleFeature refererIsLogin={refererIsLogin} feature={features.HeaderFeature} />} />
  </Switch>
)

HeaderRoutes.propTypes = {
  refererIsLogin: PropTypes.bool
}

HeaderRoutes.defaultProps = {
  routes: []
}

export default HeaderRoutes



// WEBPACK FOOTER //
// ./src/App/Header/HeaderRoutes.js